import Treeview from 'accessible-menu/treeview'

export class MenuNavmainController {
  navWithTriggerElement
  nav
  menuElement
  controllerElement
  containerElement
  menu

  constructor () {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        this.navWithTriggerElement = document.getElementById('header-nav')
        this.nav = document.getElementById('navmain')
        this.menuElement = this.nav.querySelector('ul')
        this.controllerElement = document.querySelector('#header-nav > button')
        this.containerElement = document.querySelector('#navmain-collapse')


        // on mobile, close first level initially?
        // this.menuElement.querySelectorAll('a')
        //   .forEach(el => {
        //     el.setAttribute('aria-expanded', 'false')
        //   }
        // )

        // iniitialize
        this.menu = new Treeview({
          menuElement: this.menuElement,
          containerElement: this.containerElement,
          controllerElement: this.controllerElement,
        })

        // additional functionality
        this.navWithTriggerElement.addEventListener('focusout', ev => {
          if (this.controllerElement.getAttribute('aria-expanded') !== 'true') {
            return
          }

          if (ev.relatedTarget === null) {
            return
          }

          if (this.containerElement.contains(ev.relatedTarget)) {
            return
          }

          this.closeMenu()
        })

        // overrides
        const mainLinks = document.querySelectorAll('#navmain > ul > li > a')
        mainLinks.forEach((
            element) => {
            // override sublevel toggling; does not support keyboard, though
            element.addEventListener(
              'click',
              (ev) => {
                // e.defaultPrevented = false
                ev.stopPropagation()
                // e.stopImmediatePropagation()
                // window.location.href = element.href
              },
              true
            )
          }
        )
      }
    )
  }

  closeMenu () {
    this.controllerElement.click()
  }
}
